<section class="platform-feature">

    <div class="container-redesign">

        <div
            class="platform-feature__wrapper"
            [class.platform-feature__wrapper--reverse]="!imageLeft">

            <div class="platform-feature__image">

                <img
                    [src]="image"
                    [alt]="imageAlt">

            </div>

            <div class="platform-feature__content">

                <h2 class="platform-feature__title">

                    {{ title }}

                </h2>

                <p
                    *ngFor="let paragraph of paragraphs; trackBy: trackByIndex"
                    class="platform-feature__paragraph">

                    {{ paragraph }}

                </p>

            </div>

        </div>

    </div>

</section>